<header class="header profile-header">
  <div class="Flexbox">
    <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
      <gen-test-header-elements
        class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section"
        style="font-size: 1.21rem; flex-wrap: wrap; flex: 1 1 auto"
        [headerFieldsView]="config?.headerFieldsView"
        [patientId]="patientId">
      </gen-test-header-elements>
    </div>
  </div>
</header>
